/**
 * channelHelp — geteilte, kundenfreundliche Texte/Portale je Kanal.
 *
 * Wird von RedirectUriHelp und ChannelSetupAssistant genutzt (kein Duplikat).
 * Bewusst einfache Sprache, keine Entwickler-Begriffe in den sichtbaren Texten.
 */

// Kanal → Portal-Name, wo eintragen, Direktlink
export const PORTALS = {
  google_business: { label: "Google Business", portal: "Google Cloud Console", where: "OAuth-Client → „Autorisierte Weiterleitungs-URIs“", url: "https://console.cloud.google.com/apis/credentials" },
  facebook:        { label: "Facebook & Instagram", portal: "Meta für Entwickler", where: "App → Facebook-Login → „Gültige OAuth-Weiterleitungs-URIs“", url: "https://developers.facebook.com/apps" },
  instagram:       { label: "Facebook & Instagram", portal: "Meta für Entwickler", where: "App → Facebook-Login → „Gültige OAuth-Weiterleitungs-URIs“", url: "https://developers.facebook.com/apps" },
  tiktok:          { label: "TikTok", portal: "TikTok für Entwickler", where: "App → „Redirect URI“", url: "https://developers.tiktok.com" },
  linkedin:        { label: "LinkedIn", portal: "LinkedIn Entwickler", where: "App → Auth → „Authorized redirect URLs“", url: "https://www.linkedin.com/developers/apps" },
  threads:         { label: "Threads", portal: "Meta für Entwickler (Threads)", where: "App → „Redirect Callback URLs“", url: "https://developers.facebook.com/apps" },
  pinterest:       { label: "Pinterest", portal: "Pinterest für Entwickler", where: "App → „Redirect URIs“", url: "https://developers.pinterest.com/apps" },
};

// Ein einfacher Einleitungssatz je Kanal (was es ist)
export const CHANNEL_INTRO = {
  google_business: "Damit kann der KI Social Media Manager Beiträge in deinem Google-Unternehmensprofil veröffentlichen.",
  facebook:        "Damit kann der KI Social Media Manager auf deiner Facebook-Seite (und Instagram) posten.",
  instagram:       "Instagram wird gemeinsam mit Facebook eingerichtet — kein separater Schritt nötig.",
  tiktok:          "Damit kann der KI Social Media Manager Videos auf dein TikTok-Konto stellen.",
  linkedin:        "Damit kann der KI Social Media Manager auf LinkedIn für dich posten.",
  threads:         "Damit kann der KI Social Media Manager Beiträge auf Threads veröffentlichen.",
  pinterest:       "Damit kann der KI Social Media Manager Pins für dich erstellen.",
};

/** Endet der Env-Key auf REDIRECT_URI? (= Portal-Eintrag, vom Kunden machbar) */
export function isRedirectKey(key) {
  return typeof key === "string" && key.endsWith("REDIRECT_URI");
}

/**
 * Übersetzt die technische missing_env-Liste in zwei einfache Kategorien:
 *  - needsCredentials: Zugangsdaten (App-ID/Secret) fehlen → Administrator-Aufgabe
 *  - needsRedirect:    Weiterleitungs-Adresse muss noch ins Portal eingetragen werden
 */
export function categorizeMissing(missingEnv = []) {
  const needsRedirect = missingEnv.some(isRedirectKey);
  const needsCredentials = missingEnv.some((k) => !isRedirectKey(k));
  return { needsCredentials, needsRedirect };
}
